import React from 'react';
import styled from 'styled-components/macro';
import { Container } from 'semantic-ui-react';
import { ButtonEnums, ButtonLink } from 'components/atoms';
import { PopularSearches } from 'components/pages/PageSearch/PopularSearches';
import { Routes } from 'constants/index';
import { getPath } from 'utils';

interface Props {
  searchQuery: string;
  popularSearches?: State.InternalLink[] | null;
}

export const SearchNotFound: React.FC<Props> = ({ searchQuery, popularSearches }) => (
  <Background>
    <Container>
      <div>No search results found for </div>
      <TermContainer>{searchQuery}</TermContainer>
      <div>Tips for your next search:</div>
      <List>
        <ListItem>Check the spelling of your keyword</ListItem>
        <ListItem>Try a variation or a more general version of the keyword</ListItem>
        <ListItem>Enter fewer keywords</ListItem>
      </List>
      <PopularSearches popularSearches={popularSearches} />
      <ButtonLink
        variant={ButtonEnums.variants.primary}
        bordered
        testId="search-return-to-homepage"
        size={ButtonEnums.sizes.large}
        to={getPath(Routes.FEED)}
      >
        Return to your homepage
      </ButtonLink>
    </Container>
  </Background>
);

const Background = styled.div`
  &&& {
    height: 100%;
    padding: ${props => props.theme.pxToRem(40)} 0;
    background-color: ${props => props.theme.colors.neutralGrey1};
    color: ${props => props.theme.colors.neutralGrey8};
    font-size: ${props => props.theme.fontSizes.m};
    font-weight: ${props => props.theme.fontWeights.light};
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;

    ${props => props.theme.mediaQueries.mobileOnly} {
      min-height: fit-content;
    }
  }
`;

const List = styled.ul`
  &&& {
    padding: 0;
    margin: 0;
    margin-left: ${props => props.theme.pxToRem(20)};
    margin-bottom: ${props => props.theme.pxToRem(32)};
  }
`;

const ListItem = styled.li`
  &&& {
    padding-top: ${props => props.theme.pxToRem(8)};
  }
`;

const TermContainer = styled.div`
  padding-top: ${props => props.theme.pxToRem(24)};
  padding-bottom: ${props => props.theme.pxToRem(32)};
  overflow-wrap: break-word;
  word-wrap: break-word;
  font-size: ${props => props.theme.fontSizes.xxl};
  line-height: 1.35;

  ${props => props.theme.mediaQueries.mobileOnly} {
    padding-top: ${props => props.theme.pxToRem(8)};
  }
`;
